export default __webpack_public_path__ + "static/media/bg-bottom-left.da97bea4.svg";